'use client';

import { Clock } from 'lucide-react';

export interface WaitingRoomProps {
  position: number;
  estimatedWait: string;
  providerName: string;
}

export function WaitingRoom({ position, estimatedWait, providerName }: WaitingRoomProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-page px-4">
      <div className="w-full max-w-md space-y-6 rounded-2xl bg-white p-8 text-center shadow-card">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-statura-green-accessible/10">
          <Clock className="h-8 w-8 text-statura-green-accessible" />
        </div>
        <h2 className="font-heading text-section-title text-text-heading">Waiting Room</h2>
        <p className="font-body text-body-sm text-text-muted">
          You&apos;re in the queue to see <strong>{providerName}</strong>
        </p>
        <div className="rounded-xl bg-surface-soft p-6">
          <p className="font-body text-[2.5rem] font-bold leading-none text-text-heading">
            {position}
          </p>
          <p className="mt-1 font-body text-eyebrow uppercase text-text-muted">Position in Queue</p>
        </div>
        <p className="font-body text-body-sm text-text-muted">
          Estimated wait: <strong>{estimatedWait}</strong>
        </p>
        <p className="font-body text-caption text-text-subtle">
          Please keep this page open. You&apos;ll be connected automatically.
        </p>
      </div>
    </div>
  );
}
